module.exports = __webpack_public_path__ + "static/img/dian-bg.a9e5a988.png";